webpackJsonp([273977039715485],{

/***/ 1231:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"slug":"/es/protections-coverages/","langKey":"es"}}

/***/ })

});


// WEBPACK FOOTER //
// path---es-protections-coverages-b224ee2d6e23a7013c76.js